"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reduxSaga = _interopRequireDefault(require("redux-saga"));
var _config = require("../api/config");
var _appconfig = _interopRequireDefault(require("../api/appconfig"));
var _menu = _interopRequireDefault(require("../api/menu"));
var _notifications = _interopRequireDefault(require("../api/notifications"));
var _session = _interopRequireDefault(require("../api/session"));
var _profile = _interopRequireDefault(require("../api/profile"));
var _ua = _interopRequireDefault(require("../api/ua"));
var _reducers = _interopRequireDefault(require("../reducers"));
var _sagas = _interopRequireDefault(require("../sagas"));
var actions = _interopRequireWildcard(require("../actions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const store = {
  instance: null,
  initStore(config, locale) {
    if (this.instance) {
      this.instance.dispatch(actions.updateSagaContext(config, locale));
      return this.instance;
    }
    const AxiosInstance = (0, _config.makeInstance)(config);
    const sagaMiddleware = (0, _reduxSaga.default)({
      context: {
        config,
        locale,
        appconfigApi: (0, _appconfig.default)(config, AxiosInstance),
        menuApi: (0, _menu.default)(config, AxiosInstance),
        notificationsApi: (0, _notifications.default)(config, AxiosInstance),
        sessionApi: (0, _session.default)(config, AxiosInstance),
        profileApi: (0, _profile.default)(config, AxiosInstance),
        uaApi: (0, _ua.default)(config, AxiosInstance)
      }
    });
    const composeEnhancers = "production" !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: 'AppFrame'
    }) : _redux.compose;
    const reduxStoreInstance = (0, _redux.createStore)((0, _reducers.default)(config), composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware)));
    sagaMiddleware.run(_sagas.default);
    this.instance = reduxStoreInstance;
    return reduxStoreInstance;
  }
};
var _default = exports.default = store;